import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { useState } from 'react';
import AssignmentCardResourceDialog from './AssignmentCardResourceDialog';
import AssignmentCardPlannedResourceView from './AssignmentCardPlannedResourceView';
import ResourceSectionTableHeader from './ResourceSectionTableHeader';
import usePlannedResourceResolver from './usePlannedResourceResolver';
import { PlannedResource } from 'components/IAP/hooks/assignmentListHooks';

type AssignmentCardResourceSectionProps = {
  plannedResources: PlannedResource[] | null;
  actualStatus: string | null;
  walaId: string | null;
};

const AssignmentCardResourceSectionView = ({
  plannedResources,
  actualStatus,
  walaId,
}: AssignmentCardResourceSectionProps) => {
  const plannedResourceData = usePlannedResourceResolver(plannedResources, walaId);

  const [showResourceModal, setShowResourceModal] = useState(false);

  return (
    <>
      <div className="d-flex flex-row align-items-center fw-bold mb-2 gap-2">
        <span>PRATUS Resources Planned for Use:</span>
        <StylishNewButton
          className="btn-sm border border-neutral-500 bg-dark"
          onClick={() => setShowResourceModal(true)}
          disabled={
            actualStatus === 'awaiting_review' ||
            actualStatus === null ||
            walaId === null
          }
        >
          + Attach Resources
        </StylishNewButton>
      </div>
      {plannedResourceData.length !== 0 && (
        <div className="m-2">
          <ResourceSectionTableHeader />
          {plannedResourceData.map((res, idx) => (
            <AssignmentCardPlannedResourceView
              key={`${res.id}-${idx}`}
              plannedResource={res}
            />
          ))}
        </div>
      )}
      {showResourceModal && walaId && (
        <AssignmentCardResourceDialog
          walaId={walaId}
          onClose={() => setShowResourceModal(false)}
          plannedResources={plannedResources}
        />
      )}
    </>
  );
};

export default AssignmentCardResourceSectionView;
